export default __webpack_public_path__ + "static/media/stairs_desk.9aff7847.png";